(function () {
  try {
    if (!('closest' in Element.prototype)) return;

    /* Chrome 121+ : speculation rules (theme.liquid) gère déjà le prefetch — éviter le double. */
    if (document.querySelector('script[type="speculationrules"]')) return;

    var host = location.hostname;
    var prefetched = Object.create(null);

    /** @returns {boolean} */
    function eligible(a) {
      if (!a || !a.getAttribute || a.target === '_blank' || a.download) return false;
      if (a.getAttribute('data-no-prefetch') !== null) return false;

      try {
        var url = new URL(a.href);
        if (url.hostname !== host) return false;
        if (/^(mailto:|tel:|javascript:)/i.test(url.protocol)) return false;

        var p = url.pathname.toLowerCase();
        if (p.includes('/challenge')) return false;
        /* Pages catalogue uniquement — pas de prefetch HTML home/pages légales en arrière-plan. */
        if (!p.startsWith('/products/') && !p.startsWith('/collections/')) return false;

        return true;
      } catch (_) {
        return false;
      }
    }

    function key(url) {
      try {
        var u = new URL(url, location.href);
        return u.origin + u.pathname + u.search;
      } catch (_) {
        return '';
      }
    }

    /** @param {HTMLAnchorElement} anchor */
    function prefetch(anchor) {
      var k = key(anchor.href);
      if (!k || prefetched[k]) return;
      prefetched[k] = true;

      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = k;
      link.fetchPriority = 'low';
      document.head.appendChild(link);
    }

    var hoverTimer;
    document.addEventListener(
      'mouseover',
      function (event) {
        var anchor = event.target && event.target.closest && event.target.closest('a[href]');
        if (!eligible(anchor)) return;

        clearTimeout(hoverTimer);
        hoverTimer = window.setTimeout(function () {
          prefetch(anchor);
        }, 180);
      },
      true
    );

    document.addEventListener(
      'mousedown',
      function (event) {
        var anchor = event.target && event.target.closest && event.target.closest('a[href]');
        if (!eligible(anchor)) return;

        prefetch(anchor);
      },
      true
    );

    document.addEventListener(
      'touchstart',
      function (event) {
        var anchor = event.target && event.target.closest && event.target.closest('a[href]');
        if (!eligible(anchor)) return;

        prefetch(anchor);
      },
      { passive: true, capture: true }
    );
  } catch (_) {}
})();
